import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation CurriculumDuplicate($cuid: String!){
        curriculum_duplicate (cuid: $cuid) {
            uid
        }
    }
`;

export async function curriculumDuplicate(cuid: string): Promise<string> {
    const result: FetchResult<{ curriculum_duplicate: { uid: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { cuid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.curriculum_duplicate.uid;
}
